/**
 * `/sign-in` route — Clerk-rendered sign-in form (RLY-013 AC #2).
 *
 * Uses Clerk's `<SignIn />` widget in `routing="path"` mode so deep-linked
 * Clerk steps (e.g. `/sign-in/factor-one`) resolve cleanly. The signup path
 * lives next door at `/sign-up` (also Clerk-rendered).
 *
 * After a successful sign-in the user lands on `/` by default; we override
 * via the `afterSignInUrl` prop only if/when a post-signin destination is
 * needed (RLY-024 introduces a real dashboard).
 */

import { SignIn } from "@clerk/clerk-react";

export function SignInPage() {
  return (
    <main
      aria-label="Sign in"
      className="flex min-h-screen items-center justify-center bg-background p-8"
    >
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
    </main>
  );
}

export default SignInPage;
